// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3131) return "css/homepage-7ae4bf5c244f38a94322.css";
	if (chunkId === 3130) return "css/page_insertion-27204823464d06432ba7.css";
	if (chunkId === 5329) return "css/page_affiliation-e9409f72b4f97e7925bb.css";
	if (chunkId === 3092) return "css/page_partnership-6adfa8256bd99ea11d84.css";
	if (chunkId === 484) return "css/page_pay-e318da09bddd7a44194c.css";
	if (chunkId === 7663) return "css/general_widget-3bbd0569a822f1bcce8a.css";
	if (chunkId === 9984) return "css/common_widget-1f0fc1f2d03aab9e9b0f.css";
	// return url for filenames based on template
	return "css/" + chunkId + ".css";
};